import React from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const SnackBar = ({
  snackOpen,
  handleSnackClose,
  textMessage,
  severity,
  color
}) => {
  return (
    <>
      <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={handleSnackClose}
      >
        <MuiAlert
          onClose={handleSnackClose}
          severity={severity}
          variant="filled"
          color={color}
        >
          {textMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default SnackBar;
